import { useQuery } from '@tanstack/react-query'
import { citiesApi } from '@/api/cities'

export const cityKeys = {
  all: ['cities'] as const,
  list: (parentId: number) => [...cityKeys.all, 'list', parentId] as const,
  path: (id: number) => [...cityKeys.all, 'path', id] as const,
}

/** 根据 parent_id 获取子级区域列表 */
export function useCities(parentId: number, enabled = true) {
  return useQuery({
    queryKey: cityKeys.list(parentId),
    queryFn: () => citiesApi.list(parentId),
    enabled,
  })
}

/** 根据 ID 获取完整省市区路径 */
export function useCityPath(id: number | undefined, enabled = true) {
  return useQuery({
    queryKey: cityKeys.path(id!),
    queryFn: () => citiesApi.getPath(id!),
    enabled: enabled && !!id && id > 0,
  })
}
